export default "__VITE_ASSET__Z9S_Jutq__"